<template>
    <div class="well p-5">
        <section class="flex justify-between items-center">
            <h3>
                <i
                    v-tooltip:top="'Gns. online følgere på Instagram fordelt på ugedage.'"
                    class="fa fa-info info-icon-lg"
                />
                Følgeraktivitet
            </h3>
            <span v-if="bestDay" class="text-gray-700 text-sm">Bedste dag: {{ bestDay }}</span>
        </section>

        <column-chart
            v-if="days.length > 0"
            height="220px"
            :colors="['var(--magic-color)']"
            :library="chartOptions"
            :data="days"
        />
        <div v-else class="text-sm">
            Følgeraktiviteten kan først vises to uger efter, at Instagram-profilen er konverteret til en Instagram Business-konto.
        </div>
    </div>
</template>

<style type="text/less" lang="less"></style>

<script type="text/babel">
import { capitalize } from 'dashboard-js/helpers'
import Tooltip from 'dashboard-js/directives/Tooltip'

export default {
    directives: { Tooltip },

    props: ['channelStat'],

    computed: {
        chartOptions() {
            return {
                chart: {
                    maxPadding: 50,
                    marginLeft: -20,
                    marginRight: -20,
                },
                tooltip: {
                    enabled: false,
                },
                plotOptions: {
                    column: {
                        dataLabels: {
                            enabled: true,
                            color: '#616161',
                            inside: false,
                            crop: false,
                            overflow: 'none',
                            style: {
                                fontSize: '13px',
                                textOutline: false,
                                fontWeight: 200,
                                fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
                            },
                        },
                    },
                },
                xAxis: {
                    gridLineWidth: 0,
                    minorGridLineWidth: 0,
                    minorTickLength: 0,
                    tickLength: 0,
                    lineColor: 'transparent',
                },
                yAxis: {
                    gridLineWidth: 0,
                    visible: false,
                    minorGridLineWidth: 0,
                    lineColor: 'transparent',
                },
            }
        },

        days() {
            const hoursByDays = this.channelStat.payload.followers_activity
            let days = {}

            Object.keys(hoursByDays).forEach(dayTimestamp => {
                const utcDay = moment(dayTimestamp)

                Object.keys(hoursByDays[dayTimestamp]).forEach(hour => {
                    const day = utcDay.clone().add(hour.substr(0, 2), 'hours') // Optimally we'd convert timezone here
                    const dayOfWeek = day.format('E') // 1 (mon) ... 7 (sun)

                    days[dayOfWeek] = {
                        name: capitalize(day.format('dddd')),
                        value:
                            this.$get(days, `${dayOfWeek}.value`, 0) +
                            hoursByDays[dayTimestamp][hour],
                    }
                })
            })

            return Object.keys(days).map(dayOfWeek => [
                days[dayOfWeek].name,
                Math.round(days[dayOfWeek].value / 24),
            ])
        },

        bestDay() {
            const maxValue = Math.max(...this.days.map(day => day[1]))
            return this.$get(this.days.find(day => day[1] === maxValue), 0)
        },
    },
}
</script>
